import './NavbarContent.css';
import { Link } from "react-router-dom";

export default function NavbarContent({content}) {
    return (
        <div className="navbar-content-container">
            {content.map((item, index) => (
                <Link className='navbar-content-element' key={index} to={item.link}>
                    {item.name}
                </Link>
            ))}
        </div>
    );
}